import '../styles/dochano.scss'
import React, { useState, useEffect } from 'react';
import { ReactComponent as DochanoLogo } from '../assets/d_world_Logo.svg'
import usePageTitle from '../hooks/usePageTitle';
import StandardLink from '../tools/StandardLink';

const paragraphs = {
  D: "ecisive: Makes timely and well-informed decisions on technical and operational matters.",
  O: "rganized: Effectively manages multiple projects, deadlines, and team workflows.",
  C: "ollaborative: Works seamlessly with cross-functional teams including engineering, product, and design.",
  H: "ands-on: Maintains technical proficiency and can provide guidance on coding and architecture.",
  A: "ccountable: Takes ownership of deliverables, outcomes, and team performance.",
  N: "egotiator: Mediates conflicts and aligns team priorities with organizational goals.",
  O2: "ptimistic: Inspires and motibates the team while maintaining focus on long-term objectives."
};

function Dochano() {
  usePageTitle("Dochano - Don't you know?");

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="Dochano">
      <div className="original">
        <DochanoLogo title="Donchano - Don't you know? logo" width="350" height="350" />
        <div className="content">
          <p>Pronounced "dō-chānō" which sounds similar to "Don't you know?". 
            Think of Homer Simpson saying "D'oh!" when he makes a mistake and 
            add "cha" and "no". See Merriam-Webster for <StandardLink 
              href="https://www.merriam-webster.com/dictionary/dough" 
              isNewWindow={true}>dough</StandardLink> <StandardLink 
              href="https://www.merriam-webster.com/dictionary/change" 
              isNewWindow={true}>first part of change</StandardLink> and <StandardLink 
              href="merriam-webster.com/dictionary/know" 
              isNewWindow={true}>know</StandardLink>.</p>  
          <p>This is a tribute to my youth when I would interupt my parents 
            converstion with the phrase just to join in. As a child it 
            would work in a variety of situations to get a laugh. Such as:</p>
          
          <ul>
            <li>Do you know who lives there?</li>
            <li>What time should we show up?</li>
            <li>What is her name again?</li>
            <li>etc...</li>
          </ul>

          <p>So now you know the history surrounding the name of this site.</p>
        </div>
        <div className="dochano-container">
          <div className="letter-text">DOCHANO Gregg</div>
          {Object.entries(paragraphs).map(([key, text], index) => {
            const letter = key === 'O2' ? 'O' : key;
            return (
              <div
                key={key}
                className={`paragraph ${loaded ? 'falling' : ''}`}
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="letter-text">
                  {letter}
                </div>
                <span className="rest">{text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Dochano;